import React, { useCallback, useEffect, useState } from "react";
import {
    DeleteOutlined,
    EllipsisOutlined,
    SendOutlined,
} from "@ant-design/icons";
import {
    Avatar,
    Button,
    Dropdown,
    List,
    Modal,
    Popconfirm,
    Skeleton,
    Tooltip,
    Typography,
} from "antd";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import "dayjs/locale/vi";
import "./style.css";
import toastr from "toastr";
import API from "API";
import RichEditor from "components/general/RichEditor";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { NotFound } from "AppRoute";
import { statusMapping } from "./NewsFeed";
import { roleAvatar, roleList } from "const";
import { useAuth } from "AuthContext";
import ShowFiles from "components/general/ShowFiles";
import TextWithLatex from "components/general/TextWithLatex";

dayjs.extend(relativeTime);
dayjs.locale("vi");

const { Text } = Typography;
function PostNewsFeed() {
    const { id } = useParams();
    const [loading, setLoading] = useState(false);
    const [searchParams] = useSearchParams();
    const [value, setValue] = useState({
        text: "",
        images: [],
    });
    const [comments, setComments] = useState([]);
    const [dataPost, setDataPost] = useState(null);
    const [getting, setGetting] = useState(true);
    const navigate = useNavigate();
    const { user } = useAuth();
    const getDataComments = useCallback(async (id, notGetting = false) => {
        if (!notGetting) {
            setGetting(true);
        }
        try {
            const response = await API.get(`/student/posts/${id}`);

            const data = response.data?.comments?.map((item) => ({
                ...item,
                created_at: dayjs(item.created_at),
            }));
            setComments(data);
            setDataPost({
                ...response.data,
                created_at: dayjs(response.data.created_at),
            });
        } catch (error) {
            if (error?.response?.data?.error) {
                toastr.error(error?.response?.data?.error);
                return;
            }
        } finally {
            setGetting(false);
        }
    }, []);

    const postComments = useCallback(
        async (value, dataPost) => {
            try {
                setLoading(true);
                if (!value?.text && !value?.images?.length) {
                    toastr.warning("Nội dung chưa có gì để gửi đi");
                    return;
                }
                const formData = new FormData();
                formData.append("post", dataPost?.id);
                formData.append("content", value?.text);
                for (const image of value?.images) {
                    formData.append("images", image.originFileObj);
                }
                const response = await API.post(
                    `/student/post-comments/`,
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );

                if (response.data) {
                    toastr.success("Tạo bình luận thành công");
                    getDataComments(id, true);
                    setValue({ text: "", images: [] });
                }
            } catch (error) {
                if (error?.response?.data?.error) {
                    toastr.error(error?.response?.data?.error);
                    return;
                }
            } finally {
                setLoading(false);
            }
        },
        [id, getDataComments]
    );

    const handleSend = useCallback(() => {
        postComments(value, dataPost);
    }, [postComments, value, dataPost]);

    const deleteComment = useCallback(
        async (idDelete) => {
            try {
                // setLoading(true);
                await API.delete(`/student/post-comments/${idDelete}/`);
                toastr.success("Xoá bình luận thành công");
                getDataComments(id);
            } catch (error) {
                if (error?.response?.data?.error) {
                    toastr.error(error?.response?.data?.error);
                    return;
                }
            } finally {
                // setLoading(false)
            }
        },
        [id, getDataComments]
    );

    const menuItems = (item) => {
        return [
            {
                label: (
                    <Popconfirm
                        title="Bạn có chắc muốn xoá bình luận này?"
                        onConfirm={(e) => {
                            e.stopPropagation();
                            deleteComment(item?.id);
                        }}
                        okText="Xoá"
                        cancelText="Hủy"
                    >
                        <Button
                            icon={<DeleteOutlined />}
                            type="text"
                            danger
                            onClick={(e) => {
                                e.stopPropagation();
                            }}
                        >
                            Xoá bình luận
                        </Button>
                    </Popconfirm>
                ),

                key: "0",
            },
        ];
    };

    useEffect(() => {
        if (id === undefined) return;
        getDataComments(id);
    }, [id, getDataComments]);
    return (
        <Modal
            title="Bình luận"
            open={id !== undefined}
            onCancel={() => {
                const paramsString = searchParams.toString();
                const url = `/student-posts/${
                    paramsString ? `?${paramsString}` : ""
                }`;
                navigate(url);
            }}
            footer={null}
            width={1200}
            centered
        >
            <div
                style={{
                    padding: 0,
                    maxHeight: "65vh",
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                {getting ? (
                    <Skeleton active />
                ) : dataPost === null ? (
                    <NotFound />
                ) : (
                    <>
                        <div
                            className="list-news-feeds"
                            style={{ overflowY: "auto", padding: 16, flex: 1 }}
                        >
                            <div style={{ marginTop: "10px" }}>
                                <div className="newsfeed">
                                    <div
                                        style={{
                                            display: "flex",
                                            gap: "12px",
                                            width: "100%",
                                            backgroundColor: "#fff",
                                        }}
                                    >
                                        <Tooltip title={roleList.find(item => item.role === dataPost.created_by_user.role).title}>
                                            <Avatar src={roleAvatar.find(item => item.role === dataPost.created_by_user.role).avatar} />
                                        </Tooltip>

                                        <div style={{ flex: 1 }}>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent:
                                                        "space-between",
                                                    alignItems: "center",
                                                }}
                                            >
                                                <div>
                                                    <strong
                                                        onClick={() => {
                                                            navigate(
                                                                `/users/${dataPost?.created_by_user?.id}`
                                                            );
                                                        }}
                                                        style={{
                                                            cursor: "pointer",
                                                        }}
                                                    >
                                                        {
                                                            dataPost
                                                                ?.created_by_user
                                                                .last_name
                                                        }{" "}
                                                        {
                                                            dataPost
                                                                ?.created_by_user
                                                                .first_name
                                                        }
                                                    </strong>
                                                    <Text
                                                        type="secondary"
                                                        style={{
                                                            fontSize: 12,
                                                            marginLeft: 8,
                                                        }}
                                                    >
                                                        <Tooltip
                                                            placement="topRight"
                                                            title={`${dayjs(
                                                                dataPost?.created_at
                                                            ).format(
                                                                "DD/MM/YYYY HH:mm:ss"
                                                            )}`}
                                                        >
                                                            {dayjs(
                                                                dataPost?.created_at
                                                            ).fromNow()}
                                                        </Tooltip>
                                                    </Text>
                                                    <span
                                                        style={{
                                                            fontSize: 12,
                                                            marginLeft: 5,
                                                            display:
                                                                "inline-block",
                                                            backgroundColor:
                                                                statusMapping?.find(
                                                                    ({
                                                                        status,
                                                                    }) =>
                                                                        status ===
                                                                        dataPost?.status
                                                                )?.color,
                                                            color: "#fff",
                                                            padding: "2px 8px",
                                                            borderRadius:
                                                                "99999px",
                                                        }}
                                                    >
                                                        {
                                                            statusMapping?.find(
                                                                ({ status }) =>
                                                                    status ===
                                                                    dataPost?.status
                                                            )?.text
                                                        }
                                                    </span>
                                                </div>
                                            </div>

                                            <div
                                                style={{
                                                    marginTop: 4,
                                                    wordBreak: "break-word",
                                                }}
                                            >
                                                <TextWithLatex text={dataPost?.content}/>
                                            </div>
                                            <ShowFiles files={dataPost.images}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <List
                                itemLayout="horizontal"
                                className={
                                    comments.length > 0 ? "comment-list" : ""
                                }
                                dataSource={comments}
                                renderItem={(item) => {
                                    const items = menuItems(item);
                                    return (
                                        <List.Item>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    gap: "12px",
                                                    border: "1px solid #f0f0f0",
                                                    borderRadius: "8px",
                                                    padding: "12px",
                                                    width: "100%",
                                                    backgroundColor: "#fff",
                                                }}
                                            >
                                                <Tooltip title={roleList.find(i => i.role === item.created_by_user.role).title}>
                                                    <Avatar src={roleAvatar.find(i => i.role === item.created_by_user.role).avatar} />
                                                </Tooltip>

                                                <div style={{ flex: 1 }}>
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            justifyContent:
                                                                "space-between",
                                                            alignItems:
                                                                "center",
                                                        }}
                                                    >
                                                        <div>
                                                            <strong
                                                                onClick={() => {
                                                                    navigate(
                                                                        `/users/${item?.created_by_user?.id}`
                                                                    );
                                                                }}
                                                                style={{
                                                                    cursor: "pointer",
                                                                }}
                                                            >
                                                                {
                                                                    item
                                                                        .created_by_user
                                                                        .last_name
                                                                }{" "}
                                                                {
                                                                    item
                                                                        .created_by_user
                                                                        .first_name
                                                                }
                                                            </strong>
                                                            <Text
                                                                type="secondary"
                                                                style={{
                                                                    fontSize: 12,
                                                                    marginLeft: 5,
                                                                }}
                                                            >
                                                                <Tooltip
                                                                    placement="topRight"
                                                                    title={`${item.created_at.format(
                                                                        "DD/MM/YYYY HH:mm:ss"
                                                                    )}`}
                                                                >
                                                                    {item.created_at.fromNow()}
                                                                </Tooltip>
                                                            </Text>
                                                        </div>

                                                        {(user.role < 3 || item.created_by === user.id) && <Dropdown
                                                            menu={{ items }}
                                                            trigger={["click"]}
                                                        >
                                                            <Button
                                                                type="text"
                                                                icon={
                                                                    <EllipsisOutlined />
                                                                }
                                                                style={{
                                                                    fontSize: 20,
                                                                    color: "#999",
                                                                }}
                                                            />
                                                        </Dropdown>}
                                                    </div>

                                                    <div
                                                        style={{
                                                            marginTop: 4,
                                                            wordBreak:
                                                                "break-word",
                                                        }}
                                                    >
                                                        <TextWithLatex text={item?.content}/>
                                                    </div>
                                                    <ShowFiles files={item.images}/>
                                                </div>
                                            </div>
                                        </List.Item>
                                    );
                                }}
                            />
                        </div>

                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                borderTop: "1px solid #f0f0f0",
                                padding: 12,
                            }}
                        >
                            <div
                                style={{
                                    flex: 1,
                                    marginLeft: 12,
                                    position: "relative",
                                }}
                            >
                                <RichEditor value={value} setValue={setValue} />

                                <Button
                                    loading={loading}
                                    disabled={loading}
                                    onClick={handleSend}
                                    type="text"
                                    style={{
                                        position: "absolute",
                                        right: 10,
                                        top: "50%",
                                        transform: "translateY(-50%)",
                                        fontSize: 20,
                                    }}
                                >
                                    <SendOutlined />
                                </Button>
                            </div>
                        </div>
                    </>
                )}
            </div>
        </Modal>
    );
}

export default PostNewsFeed;
